import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Archive = props => {
  return (
    <SvgIcon {...props}>
      <path d="M16 13H13.45V10H10.55V13H8L12 17L16 13ZM20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.57 5.97H5.44L6.24 5ZM19 19H5V8H19V19Z" />
    </SvgIcon>
  );
};

export default SvgI24Archive;
